import { useMutation as useApolloMutation } from "@apollo/client"

import { callMutation } from "shared/api/callMutation"
import { mapTypenameToResourceType } from "shared/api/serializer/mapTypenameToAPIType"
import {
  FloorTypename,
  ProductPositionTypename,
  ProjectTypename,
  RoomTypename
} from "shared/types/Project"

import { AttachmentEntitiesDocument } from "../graphql/attachment-entities.queries.generated"
import {
  DeleteAttachmentLinkDocument,
  DeleteAttachmentLinkMutation,
  DeleteAttachmentLinkMutationVariables
} from "../graphql/mutations.generated"
import { AttachmentsDocument } from "../graphql/project-attachments.queries.generated"

type AttachmentResourceTypename =
  | typeof ProjectTypename
  | typeof FloorTypename
  | typeof RoomTypename
  | typeof ProductPositionTypename

export function useDeleteAttachmentLink() {
  const [apolloMutate, rest] = useApolloMutation<
    DeleteAttachmentLinkMutation,
    DeleteAttachmentLinkMutationVariables
  >(DeleteAttachmentLinkDocument)

  function deleteAttachmentLink({
    id,
    resourceType,
    attachmentId
  }: {
    id: string
    resourceType: AttachmentResourceTypename
    attachmentId: string
  }) {
    const type = mapTypenameToResourceType(resourceType) ?? ""

    return callMutation(apolloMutate, {
      variables: { id, type, attachmentId },
      transform: data => data,
      apolloOptions: {
        refetchQueries: () => [
          { query: AttachmentsDocument, variables: { id, type } },
          { query: AttachmentEntitiesDocument, variables: { id: attachmentId } }
        ]
      }
    })
  }

  return [deleteAttachmentLink, rest] as [
    typeof deleteAttachmentLink,
    typeof rest
  ]
}
